import ko from "knockout";
import ViewModel from "viewModels/ViewModel";
import PlaybackHeaderView from "./PlaybackHeaderView";
import _ from "lodash";
import Icons from "enums/Icons";

const getScreenRecordingUrl = function (urlStr) {
    const url = new URL(urlStr);
    const hashWithoutQuery = url.hash.replace(/\?.*$/, "");
    const hashParts = hashWithoutQuery.split("/");
    const interactionId = hashParts.slice(
        hashParts.lastIndexOf("interactions") + 1,
        hashParts.lastIndexOf("interactions") + 2
    );

    if (_.isEmpty(interactionId)) {
        return "";
    }
    let timezoneQueryParam = "";
    if (ko.i18n.getTimezone()) {
        timezoneQueryParam =
            "?timezone=" + encodeURIComponent(ko.i18n.getTimezone());
    }
    const result = new URL(
        url.origin +
            "/screen-recording-ui/#/interactions/" +
            interactionId[0] +
            "/screen-recordings" +
            timezoneQueryParam
    );
    return result.toString();
};

export default ViewModel.extend(function (url) {
    const self = this;

    self.Icons = Icons;

    self.screenRecordingUrl = ko.observable(getScreenRecordingUrl(url));

    self.openScreenRecording = function () {
        window.open(self.screenRecordingUrl(), "_blank");
    };

    self.header = self.subView(
        PlaybackHeaderView,
        ko.i18n.renderString("playback.recording.duration"),
        "screen"
    );
});
